import React from "react";
import GooglePlayButton from "./GooglePlayButton";
import AppStoreButton from "./AppStoreButton";
import AnimatedPhoneMockup from "./AnimatedPhoneMockup";
import "../../styles/components/HomeSection/Hero.css";

const Hero: React.FC = () => {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-content">
        <p className="title-text">
          RushHour <br />
        </p>
        <p className="slogan-text">
          Blocking Without <br />
          Being Blocked
        </p>
        <p className="hero-subtitle">The solution for Parking Jam</p>
        <p className="hero-description">
          A Mobile app that helps manage car blocking situations with smart notifications and easy
          car management. Never get blocked in a parking when you need to leave!
        </p>
        <div className="hero-buttons-container">
          <GooglePlayButton />
          <AppStoreButton />
        </div>
      </div>
      <div className="hero-visual">
        <AnimatedPhoneMockup />
      </div>
    </section>
  );
};

export default Hero;
